import React, { useEffect, useState } from "react";
import { FormGroup, Page, PendingButton, required, SubmitButton, } from "components/common";

import { actions, Control, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import { filter } from "lodash";
import { validationMessage } from "constants/validationMsg";
import { isCurrency } from "../../../services/util";
import BackButton from "../../../components/refactoring/BackButton"
import { XeroClient } from "services";
import { HistoryAndNotes } from "components";


export const EditTaxRule = ({
  client,
  payroll,
  t,
  url = "tax_rules",
  model = "local",
  history,
  match,
}) => {

  const { id } = match.params;
  const multiSelectStyle = {
    chips: { background: '#72B566' },
  }
  const { dispatch, setValue, value, Form, save, loaded, load, getTitle } =
    useForm({
      model,
    });
  const [allowanceRulesOptions, setAllowanceRulesOptions] = useState([]);
  const [deductionOptions, setDeductionOptions] = useState([]);
  const [deductions, setDeductions] = useState([]);


  const onMount = async () => {
    const allowanceRules = await payroll.get("allowance_rules_options").get("data");
    const DeductionRules = await payroll.get("deduction_rules_options").get("data");
    setAllowanceRulesOptions(allowanceRules);
    setDeductionOptions(DeductionRules);
  };

  const handleSelectDeduction = (selectedList) => {
    setValue({ ...value, apply_to_deductions: selectedList });
  };

  const handleRemoveDeduction = (selectedList) => {
    setValue({ ...value, apply_to_deductions: selectedList });
  };

  const handleSelect = (selectedList) => {
    setValue({ ...value, apply_to_allowances: selectedList });
  };


  const handleRemove = (selectedList) => {
    setValue({ ...value, apply_to_allowances: selectedList });
  };
  useEffect(() => void onMount(), []);

  useEffect(() => {
    async function fetchData() {
      const item = await load(payroll, url, id, {
        description: "",
        tax_rate: "",
        amount_type: "",
        amount_type_display: "",
        apply_to_employees: [
          { name: 'Foreigner', value: false },
          { name: 'Local', value: false }
        ],
        apply_to_allowances: [],
        apply_to_deductions: [],
        apply_to_over_time: true,
        apply_to_salary: true,
        apply_to_end_of_service: false,
        apply_to_encashed_holidays: false,
        apply_to_loans: false,
      });
      setValue(item);
    }

    fetchData();
  }, [id]);

  async function onDeleteItem(deletedItem) {
    await payroll.delete(`${url}/${deletedItem}`);
    const availableDeduction = filter(value.deductions, (i) => i.id !== deletedItem)
    setDeductions(availableDeduction);
    setValue({ ...value, deductions: availableDeduction });
  }

  async function onSubmit(item) {
    item = {
      ...item,
      apply_to_allowances: item.apply_to_allowances.map((i) => i.id),
      apply_to_deductions: item.apply_to_deductions.map((i) => i.id),
    }
    try {
      dispatch(actions.setPending("local"));
      const resp = await save(payroll, url, item).get("data");
      history.replace(`/payroll/tax_rules/${resp?.id}`);
      NotificationManager.success(t("Saved successfully"));
    } finally {
      dispatch(actions.setPending(model, false));
      dispatch(actions.setSubmitted("local"));
    }
  }

  const handleKeyUp = e => {
    if (e.target.value.trim().length == 0) e.target.value = e.target.value.trim();
  };

  if (!loaded) return null;
  return (
    <Page title={getTitle(id, "Tax Rule")} className="inv-table inv-tabs mb-2">
      <BackButton />
      <Form
        className="mb-2"
        onSubmit={onSubmit}
        validators={{
          description: { required },
          tax_rate: {
            required,
            isCurrency: (val) => isCurrency(val, { min: 0.01 }),
            max: (val) => { return !(val && val > 100) },
          },
        }}
      >
        <div className="row">
          <FormGroup label="Description *" model=".description" className="col-sm pb-2 pt-2">
            <Control.text
              model=".description"
              updateOn="blur"
              placeholder="Description"
              onKeyUp={handleKeyUp} />
            <Errors
              className="form-text small text-danger"
              model=".description"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
              }}
            />
          </FormGroup>
          <FormGroup label="Tax Rate (%) *" model=".tax_rate" className="col-sm pb-2 pt-2">
            <Control.text model=".tax_rate" updateOn="blur" onKeyUp={handleKeyUp}
              placeholder="Tax Rate (.eg: 10%)"
            />
            <Errors
              className="form-text small text-danger"
              model=".tax_rate"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
                isCurrency: (val) => val && t(validationMessage.MINIMUM_CURRENCY_VALUE),
                max: t(validationMessage.MAXIMUM_PERCENTAGE_VALUE),
              }}
            />
          </FormGroup>
        </div>
        <h6 className="my-1"><Trans>Taxable Components</Trans></h6>
        <div className="row mx-1">
          <div className="col-12 col-md-6 my-1 px-0">
            <FormGroup label="Salary" className="" check>
              <Control.checkbox model={`.apply_to_salary`} />
            </FormGroup>
          </div>
          <div className="col-12 col-md-6 my-1 px-0">
            <FormGroup label="Encashed Holidays" className="" check>
              <Control.checkbox model={`.apply_to_encashed_holidays`} />
            </FormGroup>
          </div>
          <div className="col-12 col-md-6 my-1 px-0">
            <FormGroup label="End Of Service" className="" check>
              <Control.checkbox model={`.apply_to_end_of_service`} />
            </FormGroup>
          </div>
          <div className="col-12 col-md-6 my-1 px-0">
            <FormGroup label="Overtime" className="" check>
              <Control.checkbox model={`.apply_to_over_time`} />
            </FormGroup>
          </div>
          <div className="col-12 col-md-6 my-1 px-0">
            <FormGroup label="Loans" className="" check>
              <Control.checkbox model={`.apply_to_loans`} />
            </FormGroup>
          </div>
        </div>

        <fieldset>
          <div className="mx-0"><Trans>Allowances</Trans></div>
          <div className="row my-1">
            <FormGroup model=".amount" className="col-sm d-block pb-2">
              <Multiselect
                options={allowanceRulesOptions} // Options to display in the dropdown
                selectedValues={value.apply_to_allowances} // Preselected value to persist in dropdown
                onSelect={handleSelect} // Function will trigger on select event
                onRemove={handleRemove} // Function will trigger on remove event
                displayValue="description" // Property name to display in the dropdown options
                closeOnSelect
                avoidHighlightFirstOption
                showCheckbox={true}
                style={multiSelectStyle}
                placeholder={t("Select")}
                emptyRecordMsg={t('No options available')}
              />
            </FormGroup>
          </div>
        </fieldset>
        <fieldset>
          <div className="mx-0"><Trans>Deductions</Trans></div>
          <div className="row my-1">
            <FormGroup model=".amount_dedcution" className="col-sm d-block ">
              <Multiselect
                options={deductionOptions} // Options to display in the dropdown
                selectedValues={value.apply_to_deductions} // Preselected value to persist in dropdown
                onSelect={handleSelectDeduction} // Function will trigger on select event
                onRemove={handleRemoveDeduction} // Function will trigger on remove event
                displayValue="description" // Property name to display in the dropdown options
                closeOnSelect
                avoidHighlightFirstOption
                showCheckbox={true}
                style={multiSelectStyle}
                placeholder={t("Select")}
                emptyRecordMsg={t('No options available')}
              />
            </FormGroup>
          </div>
        </fieldset>
        <fieldset>
          <div className="row mx-1 my-2">
            <div><Trans>Apply To Employees</Trans></div>
            {value.apply_to_employees.map((i, indx) => (
              <FormGroup label={i.name} className="mx-2" check key={indx}>
                <Control.checkbox model={`.apply_to_employees[${indx}].value`} />
              </FormGroup>
            ))}
          </div>
        </fieldset>

        <div className="mb-3 mt-4 text-right">
          <SubmitButton className="px-3 mr-0">{id === 'new' ? t("Add") : t("Save")}</SubmitButton>
        </div>
        {id === 'new' && deductions.length > 0 && (<hr />)}
      </Form>
      {id === 'new' && deductions.length > 0 && (<Table size="sm">
        <thead>
          <tr>
            <th>
              <Trans>Description</Trans>
            </th>
            <th>
              <Trans>Tax Rate</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {deductions.map((i, idx) => (
            <tr key={i.id}>
              <td>
                {i.description}
              </td>
              <td>
                {i.tax_rate}
              </td>
              <td className="text-right">
                <PendingButton
                  size="sm"
                  color="link"
                  onClick={() => {
                    onDeleteItem(i.id);
                  }}
                >
                  <span className="fa fa-trash text-danger" />
                </PendingButton>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>)}

      <hr />

      <HistoryAndNotes
        item={value}
        contentType={'provision'}
        client={client}
        t={t}
      />
    </Page>
  );
};

export default EditTaxRule;
